import MolGrid, { Column } from "@moltech/molui/molgrid";
import React, { useEffect, useRef, useState } from "react";
import RadioButton from "../../../../../../components/ui/inputs/radioButton/RadioButton";
import Checkbox from "../../../../../../components/ui/inputs/checkBox/CheckBox";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";
import { useLazyGetContractUpcomingInvoicesNewQuery } from "../../../../../../app/services/contractAPI";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import Iconify from "../../../../../../components/ui/iconify/Iconify";
import CustomCenterModel from "../../../../../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../../../../../data/appIcons";
import FormTextAreaFields from "../../../../../../components/finalForms/formFields/FormTextAreaField";
import FormCheckboxField from "../../../../../../components/finalForms/formFields/FormCheckBoxFields";

const instrumentTypeOptions = [
  { label: "Overdue/Current", value: "Overdue/Current" },
  { label: "Upcoming", value: "Upcoming" },
  { label: "Future", value: "Future" },
  { label: "All Others", value: "All Others" },
];

const CreateInvoices = () => {
  const gridRef = useRef();
  const [selectedRadioOption, setSelectedRadioOption] = useState();
  const [isSelectChecked, setIsSelectChecked] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [selectedCheckboxRows, setSelectedCheckboxRows] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);

  /*api call*/
  const [getContractUpcomingInvoicesNew, {
    isFetching: isContractUpcomingInvoicesFetching,
    isSuccess: isContractUpcomingInvoicesFetched,
    data: ContractUpcomingInvoicesData,
  },] = useLazyGetContractUpcomingInvoicesNewQuery();

  useEffect(() => {
    let req = { plContractKey: 0, plDepartmentKey: 0, pbShowInactive: false };
    getContractUpcomingInvoicesNew(req);
  }, [getContractUpcomingInvoicesNew]);

  useEffect(() => {
    if (!isContractUpcomingInvoicesFetching && isContractUpcomingInvoicesFetched && ContractUpcomingInvoicesData) {
      if (ContractUpcomingInvoicesData) {
        setOriginalData(ContractUpcomingInvoicesData);
      }
    }
  }, [isContractUpcomingInvoicesFetching, isContractUpcomingInvoicesFetched, ContractUpcomingInvoicesData]);

  useEffect(() => {
    if (!originalData?.length) {
      setGridData([]);
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const threeMonthsLater = new Date(today);
    threeMonthsLater.setMonth(today.getMonth() + 3);
    setSelectedCheckboxRows([]);
    const filtered = originalData.filter(item => {
      const nextBillDate = item.nextBillDate
        ? new Date(item.nextBillDate)
        : null;

      if (!isSelectChecked && item.bExpired) {
        return false;
      }

      switch (selectedRadioOption || "Overdue/Current") {
        case "Overdue/Current":
          return (
            item.bSkipExceptAll === false &&
            nextBillDate &&
            nextBillDate <= today
          );

        case "Upcoming":
          return (
            item.bSkipExceptAll === false &&
            nextBillDate &&
            nextBillDate > today &&
            nextBillDate <= threeMonthsLater
          );

        case "Future":
          return (
            item.bSkipExceptAll === false &&
            nextBillDate &&
            nextBillDate > threeMonthsLater
          );

        case "All Others":
          return item.bSkipExceptAll === true;

        default:
          return true;
      }
    });

    setGridData(filtered);
  }, [originalData, selectedRadioOption, isSelectChecked]);

  const textEditor = (options) => {
    return (
      <InputText
        value={options.value || ""}
        onChange={(e) => options.editorCallback(e.target.value)}
        style={{ width: "100%" }}
        onFocus={(e) => {
          e.target.select();
        }}
      />
    );
  };

  const calenderEditor = (options) => {
    return (
      <Calendar
        selectionMode="single"
        value={options.value ? new Date(options.value) : null}
        onChange={(e) => options.editorCallback(e.value)}
      />
    )
  };

  const onCellEditComplete = (e) => {
    const { rowData, field, newValue } = e;
    setGridData((prevData) =>
      prevData.map((row) => {
        if (row.lDepartmentKey !== rowData.lDepartmentKey) {
          return row;
        }
        let finalValue = newValue;
        if (field === "amountToBill") {
          const num = parseFloat(newValue) || 0;
          finalValue = `$${num.toFixed(2)}`;
        }
        return { ...row, [field]: finalValue };
      }
      )
    );
  };

  const handleCloseModel = () => {
    setIsModelOpen(!isModelOpen);
  };

  const handleRadioChange = (e) => {
    setSelectedRadioOption(e.target.value);
  };

  const handleCheckboxChange = () => {
    setIsSelectChecked(!isSelectChecked);
  };

  return (
    <>
      <CardSection>
        <div className="create-invoice-detail">
          <div className="radio-selection-section">
            <div className="radio-box-part">
              <RadioButton
                onChange={handleRadioChange}
                selectedOption={selectedRadioOption || "Overdue/Current"}
                options={instrumentTypeOptions}
              />
            </div>
            <div className="check-box-sec ml-5">
              <Checkbox
                key="expiredContracts"
                name="expiredContracts"
                label="Show Expired Contracts"
                checked={isSelectChecked}
                onChange={handleCheckboxChange}
              // onChange={handleCheckboxChange}
              />

            </div>
            <div className="right-side-button-checkbox">
              <div className="btn-sec">
                <Buttons
                  buttonText={"Preview Invoices"}
                  buttonTypeClassName="btn blue-btn"
                // onClick={() => setIsModelOpen(true)}
                />
                <Buttons
                  buttonText={"Create Invoices"}
                  buttonTypeClassName="btn blue-btn"
                // onClick={() => setIsModelOpen(true)}
                />
              </div>
            </div>
          </div>
          <MolGrid
            ref={gridRef}
            editMode="cell"
            value={gridData}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            selection={selectedCheckboxRows}
            onSelectionChange={(e) => setSelectedCheckboxRows(e.value)}
          >
            <Column
              field="sContractName1"
              header="Contract"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "22%" }}
              grouping
              sortable
            />
            <Column
              field="sClientName1"
              header="Client"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "22%" }}
              editor={textEditor}
              onCellEditComplete={onCellEditComplete}
              grouping
              sortable
            />
            <Column
              field="sDepartmentName"
              header="Department"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
              editor={textEditor}
              onCellEditComplete={onCellEditComplete}
              grouping
              sortable
            />
            <Column
              field="create"
              header="Create"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              selectionMode="multiple"
            />
            <Column
              field="sInstallmentType"
              header="Installment Type"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
            <Column
              field="lastBillDate"
              header="Previous Invoice Date"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              colType="datetime"
              format="mm/dd/yyyy"
              grouping
              sortable
            />
            <Column
              field="nextBillDate"
              header="Invoice Date"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              colType="datetime"
              format="mm/dd/yyyy"
              editor={calenderEditor}
              onCellEditComplete={onCellEditComplete}
              body={(row) =>
                row.nextBillDate ? new Date(row.nextBillDate).toLocaleDateString("en-US") : ""
              }
              grouping
              sortable
            />
            <Column
              field="expirationDate"
              header="Expiration Date"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              editor={calenderEditor}
              onCellEditComplete={onCellEditComplete}
              colType="datetime"
              format="mm/dd/yyyy"
              body={(row) =>
                row.expirationDate ? new Date(row.expirationDate).toLocaleDateString("en-US") : ""
              }
              grouping
              sortable
            />
            <Column
              field="coveragePeriod"
              header="Coverage Period"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              editor={textEditor}
              onCellEditComplete={onCellEditComplete}
              grouping
              sortable
            />
            <Column
              field="amountToBill"
              header="Invoice Amount"
              bodyStyle={{ textAlign: "Right" }}
              style={{ width: "5%" }}
              editor={textEditor}
              onCellEditComplete={onCellEditComplete}
              colType="money"
              grouping
              sortable
            />
            <Column
              field="sNextInvoiceComment"
              header="Comment"
              bodyStyle={{ textAlign: "Center" }}
              body={(row) => (<span onClick={() => setIsModelOpen(true)}>{row?.sNextInvoiceComment?.length > 0 ? <Iconify icon="raphael:view" /> : <Iconify icon="fluent:add-12-filled" />}</span>)}
              style={{ width: "6%" }}
              grouping
              sortable
            />
          </MolGrid>
        </div>
      </CardSection>
      <div className="row">
      <CustomCenterModel
        isOpen={isModelOpen}
        useCustomBg={true}
        modalTitle={"Invoice Comment"}
        contentClass="content-35"
        onClose={handleCloseModel}
        modalTitleIcon={AppIcons.editIcon}
      >
        {/* <CardSection className="p-2 mb-1"
          cardTitle={"Contract Name - ABCD"}
        > */}
        
          <div>
            <label className="font-weight-bold ml-1 mb-2">Contract Name - ABCD</label>
          </div>
            <FormTextAreaFields 
              name={"Invoice Comment"}
            />
            <div className="ml-1">
              <FormCheckboxField labelName="Carry Forword" />
            </div>

          <div className="d-flex justify-content-center button-submit ">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="btn blue-btn w-full"
            // onClick={handaleSave}
          // isDisable={!isEditContract}
          />
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="btn secondary-btn ml-4"
            // onClick={handleCloseModel}
          />
        </div>
      </CustomCenterModel>
      </div>
    </>
  );
};

export default CreateInvoices;
